import { AnyObject, arrayToObject, objectToArray, WithId } from '@hb/shared'
import { useMemo } from 'react'

export const useRecordFromArray = <T extends WithId>(arr?: Array<T> | null) =>
  useMemo(() => arrayToObject(arr && Array.isArray(arr) ? arr : []), [arr])

export const useArrayFromRecord = <T extends AnyObject>(record?: Record<string, T> | null) =>
  useMemo(() => objectToArray(record ?? {}), [record])
